import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FundingComponent } from './funding.component';
import { CanActivateSessionGuard } from '../services/can-activate-session-guard.service';

const routes: Routes = [
    {
        path: 'funding',
        component: FundingComponent,
        canActivate: [
            CanActivateSessionGuard
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class FundingRoutingModule { }
